import { useAuthStore } from '../../stores/authStore';

/**
 * Session Context Header component.
 * Sprint 31.9 Phase 11: Displays "{Tenant Name} • {Role Name}" in header.
 * 
 * Shows the current session context next to the user avatar.
 * Provides at-a-glance visibility of which tenant+role is active.
 */
export function SessionContextHeader() {
  const { session } = useAuthStore();

  if (!session) {
    return null;
  }

  return (
    <div 
      className="session-context-header"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '6px 12px',
        borderRadius: '6px',
        background: 'var(--bg-secondary)',
        border: '1px solid var(--border-color)',
        fontSize: '13px',
        color: 'var(--text-primary)',
        whiteSpace: 'nowrap',
      }}
    >
      {/* Tenant name */}
      <span style={{ fontWeight: 500 }}>
        {session.tenantName}
      </span>
      
      {/* Separator */}
      <span style={{ color: 'var(--text-tertiary)' }}>•</span>
      
      {/* Role name with optional platform admin indicator */}
      <span style={{ 
        color: session.isPlatformAdmin ? 'var(--color-primary)' : 'var(--text-secondary)',
        fontWeight: session.isPlatformAdmin ? 500 : 400,
      }}>
        {session.roleName}
        {session.isPlatformAdmin && (
          <span 
            title="Platform Administrator"
            style={{
              marginLeft: '4px',
              fontSize: '10px',
              padding: '1px 4px',
              borderRadius: '3px',
              background: 'var(--color-primary)',
              color: 'white',
              fontWeight: 600,
              verticalAlign: 'middle',
            }}
          >
            PA
          </span>
        )}
      </span>
    </div>
  );
}
